import { gql } from "@apollo/client"

const GET_MICROSERVICES = gql`
  query getMicroservices($enterprise_id: ID!) {
    microservicesWithAssessement: countMicrosevicesWithAssessementByEntId(
      enterprise_id: $enterprise_id
    )
  }
`

const GET_BLOCKS = gql`
  query GetBlock($idBlock: ID!) {
    currentBlock: block(idBlock: $idBlock, type: "system") {
      idBlock
      block_name
      block_title
      fields {
        idField
        field_description
        field_label
        field_name
      }
    }
  }
`

const GET_PARENT_BLOCK = gql`
  query CloneBlock(
    $idBlock: ID!
    $staff_id: String!
    $organization_id: ID!
    $enterprise_id: ID
    $type: ID
  ) {
    currentBlock: block(
      idBlock: $idBlock
      type: $type
      organization_id: $organization_id
      enterprise_id: $enterprise_id
    ) {
      idBlock
      block_name
      block_title
      block_parent {
        idBlock
        block_name
        block_title
      }
      fields {
        idField
        field_label
        field_label_name
        field_name
        system_required
      }
      configuration {
        allow_custom_config
        system_required
        behavior {
          data_propagation
        }
        rules {
          assessments {
            assessment_id
            required
          }
        }
      }
    }
    systemFields: fields(
      type: "system"
      staff_id: $staff_id
      organization_id: $organization_id
      enterprise_id: $enterprise_id
    ) {
      idField
      field_label
      field_label_name
      field_name
      field_type
    }
    customFields: fields(
      type: "custom"
      staff_id: $staff_id
      organization_id: $organization_id
      enterprise_id: $enterprise_id
    ) {
      idField
      field_label
      field_name
      field_parent {
        idField
      }
    }
  }
`

const ADD_BLOCK = gql`
  mutation AddBlock(
    $organization_id: String!
    $enterprise_id: String!
    $created_by: String!
    $updated_by: String!
    $block_name: String!
    $block_parent: String
    $block_title: String!
    $configuration: String
    $fields: String!
  ) {
    addBlock(
      organization_id: $organization_id
      enterprise_id: $enterprise_id
      created_by: $created_by
      updated_by: $updated_by
      block_name: $block_name
      block_parent: $block_parent
      block_title: $block_title
      configuration: $configuration
      fields: $fields
    ) {
      block_title
    }
  }
`

const EDIT_BLOCK = gql`
  mutation EditBlock(
    $idBlock: String!
    $organization_id: String!
    $enterprise_id: String!
    $updated_by: String!
    $block_name: String!
    $block_parent: String
    $block_title: String!
    $configuration: String
    $fields: String!
  ) {
    editBlock(
      idBlock: $idBlock
      organization_id: $organization_id
      enterprise_id: $enterprise_id
      updated_by: $updated_by
      block_name: $block_name
      block_parent: $block_parent
      block_title: $block_title
      configuration: $configuration
      fields: $fields
    ) {
      block_title
    }
  }
`
const DELETE_CUSTOM_BLOCK = gql`
  mutation DeleteCustomBlock($id: String!) {
    deleteCustomBlock: deleteBlock(id: $id) {
      idBlock
    }
  }
`
const GET_BLOCKS_LIBRARY = gql`
  query Blocks($staff_id: String!, $organization_id: ID, $enterprise_id: ID) {
    systemBlocks: blocks(
      type: "system"
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      idBlock
      block_name
      block_title
      block_library
      configuration {
        allow_custom_config
        behavior {
          data_propagation
        }
      }
    }
    customBlocks: blocks(
      type: "custom"
      staff_id: $staff_id
      organization_id: $organization_id
      enterprise_id: $enterprise_id
    ) {
      idBlock
      block_name
      block_title
      block_parent_path
      enterprise_id
      organization_id
      organization_name
      enterprise_name
      block_library
      configuration {
        behavior {
          data_propagation
        }
      }
    }
  }
`
const GET_SYSTEM_BLOCKS = gql`
  query Blocks($staff_id: String!) {
    systemBlocks: blocks(type: "system", staff_id: $staff_id) {
      idBlock
      block_name
      block_title
    }
  }
`
const GET_CUSTOM_BLOCKS = gql`
  query Blocks($staff_id: String!) {
    customBlocks: blocks(type: "custom", staff_id: $staff_id) {
      idBlock
      block_name
      block_title
      enterprise_id
      organization_id
      organization_name
      enterprise_name
    }
  }
`

const GET_TEMPLATES_WITH_BLOCK_ID = gql`
  query getTemplatesWithBlockId($idBlock: ID!, $enterprise_id: ID!) {
    getTemplatesWithBlockId(idBlock: $idBlock, enterprise_id: $enterprise_id) {
      template_title
      template_name
    }
  }
`

export {
  GET_MICROSERVICES,
  GET_BLOCKS,
  GET_PARENT_BLOCK,
  ADD_BLOCK,
  EDIT_BLOCK,
  GET_BLOCKS_LIBRARY,
  GET_SYSTEM_BLOCKS,
  GET_CUSTOM_BLOCKS,
  DELETE_CUSTOM_BLOCK,
  GET_TEMPLATES_WITH_BLOCK_ID,
}
